// extracted by mini-css-extract-plugin
module.exports = {"profile":"profile_profile__3E9r3","profile__right":"profile_profile__right__2T11Z"};